/**
 * @abstract
 * @class BaseAnalyticsProvider
 *
 * This class is meant only to be extended,
 * in order to force the methods implementation
 *
 */

/**
 * @param methodName
 * @throws error in the console forcing the user to implement the method
 * @returns string This return statement is fake and its purpose is to shut down the IDE complaints
 */
function throwErrorFor(methodName) {
  throw new Error(`This method is meant to be abstract. You need to implement the ${methodName} in the subclass`);
}

/* eslint-disable */
export class BaseAnalyticsProvider {
  /**
     * @constructor
     * @param config        The configuration retrieved via Configurator
     * @param providerId    The provider id is the identifier used by the library.
     *                      i.e. for GA is 'id', for Piwik is called 'site-id' but we
     *                      generalise the name to be as much agnostic as possible
     * @param providerName  The provider name as a string
     */
  constructor(config, providerId, providerName) {
    this.config = config;
    this.providerId = providerId;
    this.providerName = providerName;
  }

  /** @abstract * */
  eventTrack(event, trackLabelInfo, trackCategoryInfo, trackActionInfo) {
    return throwErrorFor('eventTrack');
  }

  /** @abstract * */
  internalTrack(event, trackLabelInfo, trackCategoryInfo, trackActionInfo) {
    return throwErrorFor('internalTrack');
  }

  /** @abstract * */
  externalTrack(event) {
    return throwErrorFor('externalTrack');
  }

  /**
     * @description
     * Create a new event label which contains the event label from configurator and some
     * additional info that is passed through the attribute bb-track-label-info. In case
     *  if no additional info is sent we will keep the event label from configurator.
     */
  generateTrackingString(label = '', modifier) {
    if (modifier) {
      if (label) {
        return `${label} | ${modifier}`;
      }
      return modifier;
    }
    return label;
  }

  /** @abstract * */
  pageView(page) {
    return throwErrorFor('pageView');
  }

  /**
     * @abstract
     * @param config Ad hoc object retrieved via the Configurator
     * */
  static bootstrap(config) {
    return throwErrorFor('static bootstrap');
  }

  /**
     * @abstract
     * @returns {string} The name of the provider
     */
  static get name() {
    return throwErrorFor('static get name');
  }
}
